var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVbu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48.5 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main lighter",
    vectorEffect: "non-scaling-stroke",
    d: "M19.7 69.6v-6.2c10.4-1.2 9.9 3.1 9.9 3.1s.7 3.5-8.6 3.2l-1.3-.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main lighter",
    vectorEffect: "non-scaling-stroke",
    d: "M19.7 63.1v-6.2c10.4-1.2 9.9 3.1 9.9 3.1s.7 3.5-8.6 3.2l-1.3-.1zM2.4 56.8l6 12.7 5.3-12.7M34.8 56.8s-.4 12.7 5.9 12.7 5.4-12.7 5.4-12.7M41.2 54.2l1.9-4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVbu);
export default __webpack_public_path__ + "static/media/VBU.b05cdf5b88302efe54a7e70a6289e4cc.svg";
export { ForwardRef as ReactComponent };